import { render, staticRenderFns } from "./DialogShareFolder.vue?vue&type=template&id=67e86b85&scoped=true"
import script from "./DialogShareFolder.vue?vue&type=script&lang=js"
export * from "./DialogShareFolder.vue?vue&type=script&lang=js"
import style0 from "./DialogShareFolder.vue?vue&type=style&index=0&id=67e86b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e86b85",
  null
  
)

export default component.exports